<template>
  <svg height="0" width="0">
    <defs>
      <clipPath :id="shape">
        <path
            id="a"
            d="M131.592325 341.633006c-50.7622081-83.697278-73.0227025-147.743599-66.7814834-192.138963 6.2412191-44.395364 42.6260024-80.8186656 109.1543494-109.2699055l74.29046 8.1665312 82.442336 107.4446603-16.388024 152.304573-182.717638 33.493104z"
            transform="rotate(-120 164.58165396 189.78497846)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    shape: { type: String, required: true },
  },
};
</script>
